export const dynamicBi = {
  show: ['B6H5XQ21PPCM'],
  config: [
    {
      id: 1,
      cols: 4,
      children: [
        {
          id: 3,
          cols: 12,
          type: "filter",
          name: "Overview",
          logo:
            "https://cdn.discordapp.com/attachments/864703587463462932/877522344774598696/Asset_62x.png",
        },
        {
          id: "quiz",
          cols: 12,
          type: "multi",
          name: "Quiz",
          logo:
            "https://cdn.discordapp.com/attachments/864703587463462932/877522344774598696/Asset_62x.png",
        },
        {
          id: "game",
          cols: 12,
          type: "multi",
          name: "Game",
          logo:
            "https://cdn.discordapp.com/attachments/864703587463462932/877522346947272714/Asset_72x.png",
        },
      ],
    },
    {
      id: 2,
      cols: 8,
      children: [
        {
          id: "customer",
          cols: 4,
          type: "overall",
          name: "Customer",
          logo:
            "https://cdn.discordapp.com/attachments/864703587463462932/877522338529292358/Asset_22x.png",
        },
        {
          id: "point",
          cols: 4,
          type: "overall",
          name: "Point",
          logo:
            "https://cdn.discordapp.com/attachments/864703587463462932/877522340316074004/Asset_32x.png",
        },
        {
          id: "point_burn",
          cols: 4,
          type: "overall",
          name: "Point burn",
          logo:
            "https://cdn.discordapp.com/attachments/864703587463462932/877522341939281990/Asset_42x.png",
        },
        {
          id: "tier_summary",
          cols: 12,
          type: "chart",
          name: "Tier summary",
          logo:
            "https://cdn.discordapp.com/attachments/864703587463462932/877522343386296410/Asset_52x.png",
        },
      ],
    },
  ],
};
